/**
 * @file: downloadMediasImpl.web.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */
import { MediaWithSource } from '@euler/model';
import JSZip from 'jszip';

export async function downloadMediasImpl(
  medias: MediaWithSource[],
  options?: {
    zipFilename?: string;
    onBeforeDownload?: () => void;
    onSuccess?: () => void;
    onError?: (error: unknown) => void;
  },
) {
  const zip = new JSZip();

  let fileCount = 0;

  for (const media of medias) {
    try {
      options?.onBeforeDownload?.();

      const response = await fetch(media.url);
      if (!response.ok) {
        throw new Error(`Failed to fetch ${media.url}: ${response.statusText}`);
      }

      const blob = await response.blob();

      const url = new URL(media.url);
      const filename = url.pathname.substring(
        url.pathname.lastIndexOf('/') + 1,
      );

      zip.file(`${options?.zipFilename ?? '_MEDIAS'}/` + filename, blob);

      fileCount++;

      options?.onSuccess?.();
    } catch (error) {
      options?.onError?.(error);
    }
  }

  if (fileCount) {
    const content = await zip.generateAsync({ type: 'blob' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(content);
    link.download = options?.zipFilename ?? 'medias';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(link.href);
  }
}
